import { expireCookie, getCookie } from '../utils/cookies';
import { isValidUrl } from '../utils/url';

const navigateBack = (cookie, history) => {
  const returnUrl = getCookie(cookie);
  if (returnUrl !== undefined && returnUrl && isValidUrl(returnUrl)) {
    expireCookie(cookie);
    setTimeout(() => {
      window.location = returnUrl.toString();
    }, 100);
    return false;
  }
  history.goBack();
  return false;
};

export default navigateBack;
